<template>
  <div name="OnboardingVP2" class="d-felx" style=" width: -webkit-fill-available;">
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <OverlayGeneral v-if="loadingOn"></OverlayGeneral>
    <div class="layout-content container-fluid mt-5">
      <div class="row mt-5">
        <div class="col-12">
          <toaster-informative :show="getterTicket.show && can('3')" :type="'notification'" :hide-circle-to-icon="true"
            :contains-link="true" :link-path="'/solicitudes'" :message="getterTicket.message" />
        </div>
        <div class="col-xs-12 col-md-12 col-lg-12">
          <div class="cont-carousel carousel_VP2">
            <div style="margin-bottom: 47px">
              <h3 style="color: #546E7A">
                &#128075; Hola <b> {{ user.name }}</b>
              </h3>
              <h2 style="color: #263238">Te damos la bienvenida</h2>
            </div>
            <!-- end -->

            <vueper-slides autoplay
                           :pause-on-hover="false"
                           :slide-content-outside="false"
                           class="no-shadow"
                           :visible-slides="1.5"
                           :gap="1"
                           :slide-ratio="1 / 4"
                           :dragging-distance="170">
                  <vueper-slide v-for="(data, index) in onboardingData" :key="data.id"
                                :style="'background-color: ' + ['#ffffff', '#ffffff'][index % 2]">
                    <template #content>
                      <img :src="serverPath + '/' + data.image" alt="user print" class="mb-0 mb-md-0 img_carousel" />
                      <div class="row">
                        <div class="col-xs-12 col-lg-12 col-xl-12 text-center"></div>
                        <div class="mt-0 text-left" style="
                                width: 428px;
                                heigh: 84px;
                                position: absolute;
                                top: 20px;
                                left: 60px;
                              ">
                          <h3 style="color: #F96419; margin-top: 20px">
                            {{ data.title }}
                          </h3>
                          <p class="body_regular" style="color: #37474F">
                            {{ data.text }}
                          </p>
                          <div v-if="index + 1 === onboardingData.length && user.core_role_id === 6"
                               class="mt-3 mt-md-5 mb-3"
                               align="left">
                            <router-link to="/settle" class="button-primary" style="
                                    position: static;
                                    width: 89px;
                                    height: 32px;
                                    left: 0px;
                                    top: 140px;
                                    padding:4px 10px;
                                  "><span class="cta-small" style="width: 100%">Empezar</span></router-link>
                          </div>
                          <div v-else-if="data.link != null && onboardingData.length > 0" class="mt-3 mt-md-5 mb-3"
                               align="left" style="bottom: 40px;position:fixed">
                            <router-link :to="{ path: data.link }" class="button-primary" style="
                                    position: static;
                                    width: 89px;
                                    height: 32px;
                                    left: 0px;
                                    top: 140px;
                                    padding:4px 10px;
                                  "><span class="cta-small" style="width: 100%">Empezar</span></router-link>
                          </div>
                        </div>
                      </div>
                    </template>
                  </vueper-slide>
            </vueper-slides>

          </div>
        </div>
         <ComingSoon v-if="validModule('health-tracker')" class="col-10 mx-auto" />
        <!-- .col -->
      </div>
      <!-- .row -->
      <!-- modal -->
      <b-modal hide-footer :visible="getterTicket.show && can('3')" no-close-on-esc no-close-on-backdrop centered>
        <template #modal-title />
        <div class="d-block text-center">
          <div class="col-12 pb-3">
            <i class="icon-notification fa-9x" style="color: #E06100; font-size: 60px" />
          </div>
          <toaster-informative :show="true" :type="'notification'" :hide-circle-to-icon="true"
            :message="getterTicket.message" />
          <a class="h5" style="cursor: pointer; color: #000000" @click.prevent="$router.push('/solicitudes')">
            <u> Haz click acá para gestionar tus solicitudes pendientes. </u>
          </a>
        </div>
      </b-modal>
      <!-- end -->
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import ComingSoon from "@/components/healthTracker/comingSoon.vue";
import serverConfig from "@/services/config";
import HeadingUser from "@/components/user/HeadingUser.vue";
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import OverlayGeneral from "@/components/core/overlay/overlay-general.vue";
export default {
  name: "OnboardingVP2",
  components: {
    HeadingUser,
    ComingSoon,
    VueperSlides,
    VueperSlide,
    OverlayGeneral,
    toasterInformative: () =>
      import("@/components/common/toasters/Informative.vue"),
    // modalMixed: () => import('@/components/common/Modals/ModalMixed.vue')
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      slide: 0,
      sliding: null,
      onboardingData: [],
    };
  },
  created() {
    this.actUser();
  },
  async beforeMount() {
    if (
        this.canWithCode('aprobador')
    ) {
      await this.getCount()
    }
    await this.actGetOnboarding()
      .then(() => {
        this.onboardingData = this.onboarding.data;
      })
      .catch((response) => {
        this.error.flag = true;
        this.error.class = "is-invalid";
        this.error.message =
          "No se pudo conectar al servicio: error: " + response;
      });
    await this.actUserLocalStorage();
    await this.modalNPS();
  },
  computed: {
    ...mapState("modCore", ["user", "onboarding", "loadingOn"]),
    ...mapGetters("modLicenseTickets", ["getterTicket"]),
  },
  methods: {
    ...mapActions("modCore", [
      "actGetOnboarding",
      "actUser",
      "actUserLocalStorage",
    ]),
    ...mapActions("modLicenseTickets", ["getCount"]),
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    modalNPS() {
      if (this.validateNPS(this.user)) {
        window.test(this.user.sharp_id);
      }
    },
    validateNPS(user) {
      if (
        typeof user === 'object' &&
        user.sharp_id !== null &&
        user.sharp_id.length < 9
      )
        return true;
      return false;
    }
  },
};
</script>
<style lang="scss" scoped>
/** Carousel */
#OnboardingVP2 {

  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #1C3A4E;
    padding-left: 5%;
    text-align: justify;
  }

  #loader2 {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 150px 0 0 -75px;
  }

  #myDiv {
    display: none;
    text-align: center;
  }
}
</style>
<style lang="scss">
.cont-carousel.carousel_VP2 {
  // width: 640px;
  /*height: calc(100vh - 70px);
  padding-top: 50px;
  margin-bottom: 70px;
  @media (min-width: 768px) {
    padding-top: calc(50% - 300px);
  }
  @media (min-width: 992px) {
    padding-top: calc(50% - 150px);
  }
  @media (min-width: 1200px) {
    padding-top: calc(50% - 300px);
  }*/
  margin-left: 34px;
  margin-top: 44px;

  .carousel-inner {
    height: 290px !important;
  }

  .carousel-item {
    left: -65%;
    position: relative;
    display: inline;
    /* float: left; */
    width: 50%;
    visibility: visible;
  }

  .carousel-item-next {
    left: 65%;
    position: relative;
    display: inline;
    /* float: left; */
    width: 100%;
    visibility: visible;
    margin-right: 0% !important;
    margin-right: 0% !important;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transition: transform 0.6s ease-in-out;
  }

  .carousel-item.active {
    position: initial !important;
    visibility: inherit;
  }

  .carousel-item-prev {
    position: relative !important;
    left: 25%;
    display: none !important;
    visibility: hidden;
    margin-right: 0% !important;
    -webkit-backface-visibility: visible;
    backface-visibility: visible;
    transition: transform 0.6s ease-in-out;
  }

  .carousel-item-next {
    left: 65% !important;
    display: inline !important;
    position: relative;
    visibility: hidden !important;
    /* float: left; */
    width: 50% !important;
    margin-right: 0% !important;
    -webkit-backface-visibility: visible;
    backface-visibility: visible;
    transition: transform 0.6s ease-out;
  }

  .img-fluid {
    max-width: 100%;
    height: 380px !important;
  }

  .carousel-indicators {
    margin-right: 0px !important;
    width: 712px !important;
    top: 300px !important;
  }

  .carousel-indicators li {
    list-style-image: url("../../assets/images/onboarding/li_circulo.svg") !important;
    background-color: transparent !important;
  }

  .carousel-indicators .active {
    list-style-image: url("../../assets/images/onboarding/li_circulo_active.svg") !important;
    background-color: transparent !important;
    margin-top: 5px !important;
  }

  .img_carousel {
    position: absolute;
    right: 0;
    top: 0;
    border-radius: 16px;
  }

  span.carousel-control-prev-icon {
    background-image: url("../../assets/images/onboarding/icon_previus.svg") !important;
    width: 28px;
    height: 28px;
    background: #FFFFFF;
    border-radius: 100px;
  }

  span.carousel-control-next-icon {
    background-image: url("../../assets/images/onboarding/icon_next.svg") !important;
    width: 28px;
    height: 28px;
    background: #FFFFFF;
    //color: navy;
    // content: ">";
    border-radius: 100px;
  }

  span.carousel-control-next-icon:hover {
    background-image: url("../../assets/images/onboarding/icon_next_hover.svg") !important;
  }

  span.carousel-control-prev-icon:hover {
    background-image: url("../../assets/images/onboarding/icon_next_hover.svg") !important;
    transform: rotate(180deg);
  }
}

.vueperslide {
  top: 0px;
  //width: 712px !important;
  height: 288px;
  border: 1px solid #ECEFF1;
  box-sizing: border-box;
  border-radius: 16px;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}

.vueperslide--active {
  top: 0px;
  width: 712px !important;
  height: 288px;
  border: 1px solid #ECEFF1;
  box-sizing: border-box;
  border-radius: 16px;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}

.vueperslides__arrow svg {
  //background-image: url("../../assets/images/onboarding/icon_next.svg") !important;
  width: 0px;
  height: 0px;
  background: #D64E4E;
  border-radius: 0px;
  stroke: none;
  padding: 0px;
  transition: none !important;
  //right:50px;
}

.vueperslides__arrow {
  position: absolute !important;
  top: -30px !important;
  // width: 50px !important;
  align-items: flex-start !important;
  opacity: 1 !important;
  transform: translateY(0%);
  transition: none !important;
}

.vueperslides__arrows--outside .vueperslides__arrow--prev {
  background-image: url("../../assets/images/onboarding/icon_previus.svg") !important;
  width: 28px;
  height: 28px;
  right: 4.5em !important;
  left: auto !important;
  background: #FFFFFF;
  border-radius: 100px;
  //right: -200px !important;
}

.vueperslides__arrows--outside .vueperslides__arrow--next {
  background-image: url("../../assets/images/onboarding/icon_next.svg") !important;
  width: 28px;
  height: 28px;
  background: #FFFFFF;
  border-radius: 100px;
  left: auto;
  right: 1.5em;
}

.vueperslides__arrows--outside .vueperslides__arrow--next:hover {
  background-image: url("../../assets/images/onboarding/icon_next_hover.svg") !important;
}

.vueperslides__arrows--outside .vueperslides__arrow--prev:hover {
  background-image: url("../../assets/images/onboarding/icon_next_hover.svg") !important;
  transform: rotate(180deg);
}

.vueperslides__bullet .default {
  background-image: url("../../assets/images/onboarding/li_circulo.svg") !important;
  background-color: transparent !important;
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 8px;
  height: 8px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0px;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

.vueperslides__bullet--active .default {
  background-image: url("../../assets/images/onboarding/li_circulo_active.svg") !important;
  background-color: transparent !important;
  width: 16px;
  height: 16px;
}

.vueperslides__bullet {
  top: -30px !important;
  justify-content: left !important;
  left: 355px !important;
}

.vueperslides__parallax-wrapper {
  padding-bottom: 300px !important;
}
</style>